module.exports = __webpack_public_path__ + "static/media/office_7@2x.9740d96a.jpg";